import * as Styled from './RatingAverage.styled';
import React from 'react';
import { RatingAverageProps } from './RatingAverage.typed';

export const RatingAverage = (props: RatingAverageProps) => {
  const { average, reviewCount } = props;
  return (
    <Styled.AverageText size={'M16'} forwardedAs={'span'}>
      {`${average}/5`}
      <Styled.ReviewCount
        forwardedAs={'span'}
        size={'B12'}
        display={'inline'}
      >{` (${reviewCount})`}</Styled.ReviewCount>
    </Styled.AverageText>
  );
};
